/* Маршруты магазина и админки. */
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Button from './components/Button.jsx';

const ProductPage = lazy(() => import('./pages/ProductPage.jsx'));
const CartPage = lazy(() => import('./pages/CartPage.jsx'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage.jsx'));
const DonePage = lazy(() => import('./pages/DonePage.jsx'));
const LoginPage = lazy(() => import('./pages/LoginPage.jsx'));
const AccountPage = lazy(() => import('./pages/AccountPage.jsx'));
const InfoPage = lazy(() => import('./pages/InfoPage.jsx'));

const AdminLayout = lazy(() => import('./pages/admin/AdminLayout.jsx'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard.jsx'));
const AdminProducts = lazy(() => import('./pages/admin/AdminProducts.jsx'));
const AdminOrders = lazy(() => import('./pages/admin/AdminOrders.jsx'));
const AdminReviews = lazy(() => import('./pages/admin/AdminReviews.jsx'));
const AdminPromos = lazy(() => import('./pages/admin/AdminPromos.jsx'));
const AdminUsers = lazy(() => import('./pages/admin/AdminUsers.jsx'));

function PageFallback() {
  return (
    <div className="page">
      <div className="cart" style={{ minHeight: '50vh' }}>
        <div className="skeleton" style={{ height: 320, borderRadius: 'var(--r-card)' }} />
      </div>
    </div>
  );
}

function NotFound() {
  return (
    <div className="page">
      <div className="cart" style={{ minHeight: '60vh' }}>
        <div className="cart-empty" style={{ marginTop: 40 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 76, color: 'var(--accent)' }}>
            404
          </div>
          <h2>Страница не найдена</h2>
          <p>Возможно, товар уехал из дропа. Загляните в каталог — там всё на месте.</p>
          <Button to="/" size="lg">В каталог</Button>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="product/:slug" element={<ProductPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="order/:number" element={<DonePage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="account" element={<AccountPage />} />
          {['about', 'delivery', 'returns', 'offer', 'privacy'].map((page) => (
            <Route key={page} path={page} element={<InfoPage page={page} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="reviews" element={<AdminReviews />} />
          <Route path="promos" element={<AdminPromos />} />
          <Route path="users" element={<AdminUsers />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
